module.exports = __webpack_public_path__ + "img/lachssteakohnehintergrund.ed872393.png";